import { REFETCH_INTERVAL } from "@circle-react/components/SettingsApp/Emails/components/Broadcasts/constants";
import { numberFormatter } from "@circle-react-shared/uikit/TabV2/Counter";
import { useRecipientListInfiniteQuery } from "./useRecipientListInfiniteQuery";

export const useViewRecipientList = ({
  id,
  event_type,
  email,
  link,
  name,
}: {
  id: number;
  event_type: string;
  email?: string;
  link?: string;
  name?: string;
}) => {
  const { totalQueryMembers, ...membersQuery } = useRecipientListInfiniteQuery({
    id,
    event_type,
    filters: { email, link, name },
    options: {
      refetchInterval: REFETCH_INTERVAL,
    },
  });

  const formattedCount = numberFormatter(totalQueryMembers);

  return {
    formattedCount,
    count: totalQueryMembers,
    ...membersQuery,
  };
};
